import { Box, Divider, FormControlLabel, FormGroup, Grid, Stack, Switch } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/DeleteIcon.svg";
import { ReactComponent as EditIcon } from "assets/EditIcon.svg";
import { ReactComponent as ReorederSections } from "assets/ReorderSections.svg";
import { ReactComponent as CopyLink } from "assets/copy_link.svg";
import FileAdd from "assets/fileAdd";
import { ReactComponent as JoinUser } from "assets/joinUserBlackIcon.svg";
import { clearSelectedCards } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import BookmarkPlan from "components/common/Bookmark";
import Button from "components/common/Button";
import { CustomContentIcon } from "components/common/CustomContentIcon";
import DialogFormation from "components/common/DialogFormation";
import DraggableList from "components/common/DraggableList";
import Feedback from "components/common/Feedback";
import FunctionalAreas from "components/common/FunctionalAreas";
import HTMLRenderer from "components/common/HTMLRenderer";
import InfoBar from "components/common/InfoBar";
import KebabMenu from "components/common/KebabMenu";
import ButtonLink from "components/common/Link";
import MarkCompleteButton from "components/common/MarkCompleteButton";
import ScrollAwareHeader from "components/common/ScrollAwareHeader";
import { setFeedbackDetails } from "components/common/Snackbar/snackbar.slice";
import Spinner from "components/common/Spinner/Spinner";
import TargetedPlanChip from "components/common/TargetedPlanChip";
import Timing from "components/common/Timing";
import Typography from "components/common/Typography";
import UserAvatarList from "components/common/UserAvatarList";
import Calender from "components/common/calender/Calender";
import {
  addToMyPlansAsync,
  fetchMyPlanDetailAsync,
  setIsRedirectFromNotification
} from "components/features/MyPlanDetails/MyPlanDetails.slice";
import { useTranslate } from "hooks/useTranslate";
import { uniq } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { DropResult } from "react-beautiful-dnd";
import { useNavigate } from "react-router";
import { useLocation, useSearchParams } from "react-router-dom";
import { tokens } from "styles/Tokens";
import {
  ABOVE_PROPERTY,
  DEFAULT_CORP_INNCODE,
  FEEDBACK_TIMER,
  accessTypes,
  brandDeadLine,
  brandDeadlinesType,
  initiative,
  messageTypes,
  nonLeadershipUser,
  sourceValues
} from "utils/CommonConstants";
import {
  getChipDetails,
  getLoggedInUserDetails,
  getOwnersList,
  getPlanDetail,
  getPlanDuration,
  getPlantypeName,
  getUserHltId,
  isBookmarked,
  matchOwnerWithHltId,
  reorder
} from "utils/CommonFunctions";
import { formatDateMMDDYYYY, getUIFormatDate } from "utils/DateHelper";
import {
  checkTemplatePlanPayload,
  getPlanDetailsRoute,
  hasTemplatePlansAccess,
  isTemplatePlan as isTemplatePlanCheck
} from "utils/StoreUtils";
import { formTypes, planTypes } from "utils/Types";
import { REDIRECT_URI } from "utils/URLConstants";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import AccessBanner from "../../common/AccessBanner/PlanDetailAccessBanner";
import ActionCardDialogsContext from "../ActionCard/Context";
import { flowOptions, setCustomPlanCreationFlow, setPlanMode } from "../CustomPlanCreation/CustomPlanCreation.slice";
import { patchReorderSectionsAsync } from "../MyPlanDetails/MyPlanDetails.slice";
import Delete from "../MyPlans/Delete";
import Edit from "../MyPlans/Edit";
import { setIsPlanHighlight } from "../MyPlans/myplans.slice";
import PlanAssignment from "../PlanAssignment";
import MetricDetails from "../dashboard/MetricDetails";
import PlanBadge from "../dashboard/PlanBadge";
import InviteMemberDialog from "./InviteMemberDialog";
import { fetchImplementedPlansAsync, fetchUserDetailsAsync, joiningToPlanAsync } from "./PlanDetail.slice";
import "./PlanDetailsContent.scss";
import AddToMyPlans from "./addToMyPlans/AddToMyPlans";

export default function PlanDetailsContent(props: any) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isHighlightMyActionFromURL = searchParams.get("highlightMyActions");

  const { isMobileScreen }: any = useContext(ThemeContext);
  const { setIsOpenCustomPlanCreateDialog } = React.useContext(ActionCardDialogsContext);

  const { selectedPlanDetail, plansType, isPlanBookmark, redirectFromDashboard, isShareable } = props;
  const searchActive = useAppSelector((state) => state.app.searchActive);
  const { isCorp, isAbovePropertyUser, isConsultant } = useAppSelector((state) => state.app.loggedInUserDetails);
  const innCode = useAppSelector((state) => state.app.innCode);
  const activeActionCard = useAppSelector((state) => state.app.activeActionCard);
  const selectedMyPlanDetail = useAppSelector((state) => state.myPlanDetails.myPlanDetails);
  const suggestestedPlansMetrics = useAppSelector((state) => state.suggestedPlans.plansMetrics);
  const isActionHighlight = useAppSelector((state) => state.myplans?.MyPlans.isActionHighlight);
  const cardList = useAppSelector((state) => state.app.selectedCards?.cardList);
  const assigneeList = useAppSelector((state) => state.myPlanDetails.ad);
  const implementedPlansLoader = useAppSelector((state) => state.planDetails.implementedPlansLoader);
  const isSuggestedPannel = location?.state?.isSuggestedPannel;
  const isStagnant = selectedMyPlanDetail?.isStagnantPlan;
  const isViewMode = useAppSelector((state) => state.myPlanDetails.isViewMode);
  const showDashboardMetrics = location?.state?.showMetrics;
  const dashboardPlansMetrics = useAppSelector((state) => state.hotelUserDashboardSlice.suggestedPlans.plansMetrics);
  const metricsPlansList = showDashboardMetrics ? dashboardPlansMetrics : suggestestedPlansMetrics;
  const sharedSearch = location?.state?.sharedSearch;
  const { isImpersonated, userDetails }: any = useAppSelector((state) => state.app.impersonationDetails);
  const loggedInUserInfo = useAppSelector((state) => state.app.userName);
  const currentUserInfo = isImpersonated ? userDetails : loggedInUserInfo;
  const isNonLeadershipUser = currentUserInfo?.roleCategory === nonLeadershipUser;
  const [items, setItems] = useState([]);
  const [dueDate, setDueDate] = useState<any>();
  const [openDialog, setOpenDialog] = useState(Boolean);
  const [openEditPlan, setOpenEditPlan] = useState(false);
  const [reorderedData, setReorderedData] = useState({});
  const [isSaveEnabled, setIsSaveEnabled] = useState(false);
  const [isActionHighlightFromURLSet, setIsActionHighlightFromURLSet] = useState(false);
  const [openAddDueDate, setOpenAddDueDate] = useState(false);
  const [isOpenPlanAssignmentDialog, setIsOpenPlanAssignmentDialog] = useState(false);
  const [isCopyLinkSuccess, setIsCopyLinkSuccess] = useState(false);
  const [openDeleteCapthaDialog, setOpenDeleteCapthaDialog] = useState(Boolean);
  const [openInviteMemberDialog, setOpenInviteMemberDialog] = useState(Boolean);
  const [openAddToMyPlanConfirmDialog, setOpenAddToMyPlanConfirmDialog] = useState(false);
  const [openImplementedPlans, setOpenImplementedPlans] = useState(false);
  const [isAssignCopy, setIsAssignCopy] = useState(false);

  const members = assigneeList?.filter(
    (users: any) =>
      selectedMyPlanDetail?.owners?.indexOf(users?.hltId) === -1 ||
      selectedMyPlanDetail?.members?.indexOf(users?.hltId) > -1
  );
  const suggestedPlan =
    (isSuggestedPannel || showDashboardMetrics) && getPlanDetail(selectedPlanDetail.id, metricsPlansList);
  const metrics = suggestedPlan?.metrics;
  const addedToMyPlansDate = getUIFormatDate(selectedPlanDetail?.myPlans?.[0].createdDate);
  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;
  const redirectTab = searchParams.get("redirectTab") as string;

  if (redirectTab === "Comment") {
    dispatch(setIsRedirectFromNotification(true));
  }

  useEffect(() => {
    setReorderedData({
      id: selectedPlanDetail?.id,
      reorderedSections: {
        sectionIds: []
      }
    });
    setItems(selectedPlanDetail?.sections);
  }, [selectedPlanDetail]);

  const SectionMenu = isViewMode
    ? [
        {
          label: "Reorder Sections",
          icon: ReorederSections,
          accessType: accessTypes.update,
          enabled: items?.length > 1,
          action: () => {
            setOpenDialog(true);
          }
        }
      ]
    : [
        {
          label: "Edit Plan",
          icon: EditIcon,
          accessType: accessTypes.update,
          action: () => {
            if (selectedPlanDetail?.innCode === ABOVE_PROPERTY) dispatch(setPlanMode(formTypes.CreateTemplatePlan));
            setOpenEditPlan(true);
          },
          enabled: true
        },
        ...(isNonLeadershipUser && selectedPlanDetail?.isJoinPlanAllowed
          ? [
              {
                label: "Join Plan",
                icon: JoinUser,
                action: async () => {
                  const params = { id: selectedMyPlanDetail?.id, isHotelUserJoiningToPlan: true, type: "join_Plan" };
                  const payload = {
                    payload: { members: [...(selectedMyPlanDetail?.members || []), currentUserInfo?.hltId] },
                    ...params
                  };
                  const res = await dispatch(joiningToPlanAsync(payload));
                  if (res?.payload?.id)
                    dispatch(
                      setFeedbackDetails({
                        shouldShow: true,
                        variant: "success",
                        setState: setFeedbackDetails({ shouldShow: false }),
                        message: translate("myplanDetails.planJoined")
                      })
                    );
                  dispatch(fetchMyPlanDetailAsync({ id: selectedMyPlanDetail?.id, includePropertyInfo: true }));
                },
                enabled: selectedPlanDetail?.isJoinPlanAllowed
              }
            ]
          : []),
        {
          label: "Reorder Sections",
          icon: ReorederSections,
          accessType: accessTypes.update,
          enabled: items?.length > 1,
          action: () => {
            setOpenDialog(true);
          }
        },
        {
          label: "Delete Plan",
          icon: DeleteIcon,
          accessType: accessTypes.delete,
          enabled: true,
          action: () => {
            if (!isCorp && !matchOwnerWithHltId(selectedMyPlanDetail?.owners)) {
              dispatch(
                setFeedbackDetails({
                  shouldShow: true,
                  type: "plan",
                  displayName: getOwnersList(),
                  setState: setFeedbackDetails({ shouldShow: false }),
                  messageType:
                    selectedMyPlanDetail?.owners.length > 1 ? messageTypes.multipleOwners : messageTypes.singleOwner
                })
              );
              return;
            }
            setOpenDeleteCapthaDialog(true);
          }
        }
      ];

  const PlanMenu =
    isConsultant && !redirectFromDashboard
      ? [
          {
            label: "Assign Plan",
            enabled: true,
            action: () => {
              setIsOpenPlanAssignmentDialog(true);
            }
          },
          {
            label: "Copy shareable link",
            icon: CopyLink,
            action: () => {
              const link = REDIRECT_URI + "/plandetails/" + selectedPlanDetail?.id + "?isshareable=true";
              navigator.clipboard.writeText(link).then(function () {
                setIsCopyLinkSuccess(true);
              });
              setIsCopyLinkSuccess(false);
            },
            enabled: true
          }
        ]
      : [
          {
            label: "Copy shareable link",
            icon: CopyLink,
            action: () => {
              const link = REDIRECT_URI + "/plandetails/" + selectedPlanDetail?.id + "?isshareable=true";
              navigator.clipboard.writeText(link).then(function () {
                setIsCopyLinkSuccess(true);
              });
              setIsCopyLinkSuccess(false);
            },
            enabled: true
          }
        ];

  const handleCloseDialog = () => {
    setItems(selectedPlanDetail?.sections);
    setIsSaveEnabled(false);
    setOpenDialog(false);
  };

  const saveReorder = () => {
    const payload = checkTemplatePlanPayload(reorderedData);
    const { id, ...rest } = payload;
    const isTemplateCheck = isTemplatePlanCheck(selectedPlanDetail);
    const reorderPayload = checkTemplatePlanPayload(rest.reorderedSections, isTemplateCheck);
    dispatch(patchReorderSectionsAsync({ payload: reorderPayload, id }));
    setOpenDialog(false);
    setIsSaveEnabled(false);
  };

  const createSectionArray = (itemDetails: any) => {
    const reorderedList = itemDetails.map((item: { id: any }) => item.id);
    setReorderedData({
      ...reorderedData,
      reorderedSections: {
        sectionIds: [...reorderedList]
      }
    });
  };

  const onDragEnd = ({ destination, source }: DropResult) => {
    // dropped outside the list
    if (!destination) return;
    const newItems: any = reorder(items, source.index, destination.index);
    setItems(newItems);
    setIsSaveEnabled(true);
    createSectionArray(newItems);
  };

  const getOwners = () => {
    if (plansType === planTypes.MyPlans)
      return (
        <Grid item xs={12} paddingTop="12px">
          <Typography variant="label" color={tokens.Text.General.Tertiary}>
            {`Owner: `}
          </Typography>
          <Typography variant="label" showBold color={tokens.Text.General.Tertiary}>
            {getOwnersList()}
          </Typography>
        </Grid>
      );
  };

  const getPropInfo = () => {
    if (plansType === planTypes.MyPlans && !isTemplatePlan)
      return (
        <div className="prop-info-cont">
          <Typography variant="body2" color={tokens.Text.General.Tertiary}>
            {selectedMyPlanDetail?.propertyInfo?.propName}
          </Typography>
          {!isMobileScreen && <li className="bullet-point"></li>}
          <Typography variant="body2" showBold={isMobileScreen} color={tokens.Text.General.Tertiary}>
            {selectedMyPlanDetail?.innCode}
          </Typography>
        </div>
      );
  };

  const getInfoBarList: any = () => {
    return (
      <Grid
        item
        xs={12}
        sm={7}
        gap="8px"
        marginTop={isMobileScreen ? "16px" : 2}
        display="flex"
        flexWrap="wrap"
        minHeight={isMobileScreen ? "70px" : ""}
        sx={{ color: isMobileScreen ? tokens.Text.General.PrimaryBody : "" }}
        alignItems={isMobileScreen ? "inherit" : "flex-end"}
      >
        <Grid width={isMobileScreen ? "48%" : "unset"}>
          <InfoBar
            sx={{
              height: isMobileScreen ? "100%" : ""
            }}
            label={`Priority  `}
            value={selectedPlanDetail?.priority === null ? "Undefined" : selectedPlanDetail?.priority}
          ></InfoBar>
        </Grid>
        <Grid width={isMobileScreen ? "48%" : "unset"}>
          <InfoBar
            sx={{
              height: isMobileScreen ? "100%" : ""
            }}
            label={`Due Date  `}
            value={selectedPlanDetail?.dueDate ? getUIFormatDate(selectedPlanDetail?.dueDate) : ""}
          ></InfoBar>
        </Grid>
        {isViewMode ? (
          <></>
        ) : (
          <Grid width={isMobileScreen ? "100%" : "unset"}>
            <InfoBar
              sx={{
                height: isMobileScreen ? "100%" : ""
              }}
              label="Progress"
              progressChip={{
                ...getChipDetails(
                  selectedPlanDetail?.totalCards,
                  selectedPlanDetail?.cardsCompleted,
                  selectedPlanDetail?.sections ? selectedPlanDetail?.sections.map((a: any) => a.cards).flat() : []
                ),
                iconAtStart: true
              }}
            ></InfoBar>
          </Grid>
        )}
      </Grid>
    );
  };

  const getSourceValue = () => {
    const planType = getPlantypeName(selectedPlanDetail?.planType);
    if (sharedSearch) return sourceValues.sharedSearch;
    else if (isShareable) return sourceValues.sharedLink;
    else if (selectedPlanDetail?.isBookmarked) return sourceValues.bookmark;
    else if (selectedPlanDetail?.isSuggestedPlan) return selectedPlanDetail?.source;
    else if (planType === initiative) return sourceValues.initiative;
    else if (planType === brandDeadLine) return sourceValues.deadline;
    else if (searchActive) return sourceValues.librarySearch;
    else return sourceValues.library;
  };

  const addToMyPlansHandler = async () => {
    const response = await dispatch(
      addToMyPlansAsync({
        libraryPlan: selectedPlanDetail,
        innCode,
        source: getSourceValue(),
        planType: getPlantypeName(selectedPlanDetail?.planType),
        dueDate: dueDate
      })
    );

    if (response?.payload?.id) {
      dispatch(setCustomPlanCreationFlow(flowOptions["second"]));
      dispatch(setPlanMode(formTypes.AddToMyPlan));
      setIsOpenCustomPlanCreateDialog(true);
    }

    setOpenAddDueDate(false);
  };

  const handleClose = () => {
    setIsOpenPlanAssignmentDialog(false);
  };

  if (isHighlightMyActionFromURL && !isActionHighlightFromURLSet) {
    dispatch(setIsPlanHighlight(true));
  }

  useEffect(() => {
    return () => {
      dispatch(setIsPlanHighlight(false));
    };
  }, []);

  useEffect(() => {
    dispatch(setIsPlanHighlight(selectedPlanDetail?.isActionHighlight));
  }, [selectedPlanDetail]);

  const getMarkCompleteButton = () => {
    return <MarkCompleteButton source={{ source: "plan" }} />;
  };
  const handleHighlight = () => {
    const hltId: string = getUserHltId();
    const filterCards = cardList.filter((task: any) => !task.assignee || !task.assignee?.includes(hltId));
    if (!isActionHighlight) {
      filterCards.forEach((element: any) => {
        dispatch(clearSelectedCards(element));
      });
    }
    if (isHighlightMyActionFromURL) setIsActionHighlightFromURLSet(true);
    dispatch(setIsPlanHighlight(!isActionHighlight));
  };

  const HighlightAction = () => {
    return (
      <FormGroup>
        <FormControlLabel
          className="highlight-action"
          sx={{ mr: "8px", ml: 0 }}
          control={<Switch size="small" onChange={() => handleHighlight()} checked={isActionHighlight} />}
          label={
            <Typography variant="body2" color={tokens.Border.General.Secondary} sx={{ marginRight: "8px" }}>
              {translate("myplan.highlight.myActions")}
            </Typography>
          }
          labelPlacement="start"
        />
      </FormGroup>
    );
  };
  const startNewPlan = () => {
    addedToMyPlansDate ? setOpenAddToMyPlanConfirmDialog(true) : setOpenAddDueDate(true);
  };

  const getImplementedPlans = async () => {
    const payload = { innCode: innCode, cmsId: selectedPlanDetail.id };
    const resp = await dispatch(fetchImplementedPlansAsync(payload));
    const implementedPlans = resp?.payload.implementations;
    if (implementedPlans && implementedPlans?.length) {
      const planOwners = uniq(implementedPlans?.map((el: any) => el.planMembers).flat());
      await dispatch(fetchUserDetailsAsync({ hltIds: planOwners.join(","), size: planOwners?.length }));
      setOpenImplementedPlans(true);
    } else {
      startNewPlan();
    }
  };

  const getAssignPlanButtonForTemplatePlans = (isSmallHeader = false) => {
    return (
      <Button
        sx={{ marginLeft: isMobileScreen ? "auto" : "unset", flex: isSmallHeader && isMobileScreen ? 1 : 0 }}
        onClick={() => {
          if (selectedMyPlanDetail?.totalCards === 0)
            dispatch(
              setFeedbackDetails({
                shouldShow: true,
                setState: setFeedbackDetails({ shouldShow: false }),
                message: "The plan cannot be assigned as there are no action cards for the plan"
              })
            );
          else setIsOpenPlanAssignmentDialog(true);
        }}
        variant="primary"
        label="Assign plan"
        accessType={accessTypes.assign}
      />
    );
  };

  const getLibraryAllPlansActionButtons = () => {
    return (
      plansType === planTypes.AllPlans && (
        <>
          <div className="planDetailsContentActionButtons">
            {getLoggedInUserDetails()?.roleCategory === "Leadership" &&
              getLoggedInUserDetails()?.lobbyUserType !== "OW" && (
                <Button
                  variant="secondary"
                  label="Assign"
                  accessType={accessTypes.assign}
                  onClick={() => {
                    setIsOpenPlanAssignmentDialog(true);
                  }}
                />
              )}
            {hasTemplatePlansAccess() && (
              <Button
                accessType={accessTypes.update}
                variant="secondary"
                label="Save as Template Plan"
                onClick={createTemplatePlan}
              />
            )}
            {!isCorp && !redirectFromDashboard && (
              <Button
                accessType={accessTypes.update}
                variant="primary"
                label={translate("library.addToMyPlan")}
                startIcon={<FileAdd />}
                onClick={getImplementedPlans}
              />
            )}
            {isAbovePropertyUser &&
              redirectFromDashboard &&
              plansType === planTypes.AllPlans &&
              selectedPlanDetail?.inncode !== DEFAULT_CORP_INNCODE && (
                <Button
                  label="Assign plan"
                  accessType={accessTypes.assign}
                  onClick={() => {
                    setIsOpenPlanAssignmentDialog(true);
                  }}
                />
              )}
          </div>
        </>
      )
    );
  };

  const getScrollHeaderContent = () => {
    return (
      <ScrollAwareHeader elementId="infoBarRoot">
        <Typography variant="h5" showBold color={tokens.Text.General.PrimaryHeadline} sx={{ flex: 0.8 }}>
          <CustomContentIcon type="plan" isCustom={selectedMyPlanDetail.isPlanCustomized} />
          {selectedPlanDetail?.name || selectedMyPlanDetail?.name}
        </Typography>
        <Stack
          spacing={isMobileScreen ? 2 : 0}
          flex="1"
          flexDirection="row"
          alignItems="center"
          justifyContent={isMobileScreen ? "space-between" : "flex-end"}
          flexWrap="wrap"
          sx={{
            width: isMobileScreen ? "100%" : "auto",
            mt: isMobileScreen ? "16px" : "0 !important"
          }}
        >
          {plansType === planTypes.MyPlans && !isTemplatePlan && (
            <>
              {selectedMyPlanDetail?.innCode !== ABOVE_PROPERTY && <HighlightAction />}
              <Button
                sx={{
                  mr: "8px",
                  width: isMobileScreen ? "100%" : "auto",
                  minWidth: isMobileScreen ? "94px" : "116px",
                  mt: isMobileScreen ? "8px" : "0 !important"
                }}
                onClick={() => {
                  setOpenInviteMemberDialog(true);
                }}
                variant="secondary"
                label="Manage Plan Members"
              />
              {getMarkCompleteButton()}
            </>
          )}
          {getLibraryAllPlansActionButtons()}
          {plansType === planTypes.MyPlans && isTemplatePlan && getAssignPlanButtonForTemplatePlans(true)}
          {plansType !== planTypes.MulipleAssign && !isMobileScreen ? (
            <KebabMenu options={plansType === planTypes.MyPlans ? SectionMenu : PlanMenu} />
          ) : null}
        </Stack>
      </ScrollAwareHeader>
    );
  };

  const createTemplatePlan = async () => {
    const payload = {
      innCode: ABOVE_PROPERTY,
      libraryPlan: selectedPlanDetail,
      isTemplatePlanCheck: true
    };

    const response = await dispatch(addToMyPlansAsync(payload));
    if (response?.payload?.id) navigate(`/${getPlanDetailsRoute(true)}/${response?.payload?.id}`);
    if (!isViewMode) {
      dispatch(
        setFeedbackDetails({
          shouldShow: true,
          variant: "success",
          setState: setFeedbackDetails({ shouldShow: false }),
          message: translate("custom.plan.creation.template.success")
        })
      );
    }
  };

  return (
    <>
      {implementedPlansLoader && <Spinner backdropVisible />}
      <Grid id="infoBarRoot" container sx={{ backgroundColor: tokens.Background.General.Primary }}>
        {!activeActionCard?.planId && getScrollHeaderContent()}
        {selectedPlanDetail.isPlanNotImplemented && <PlanBadge navigate={navigate} data={selectedPlanDetail} />}
        {selectedPlanDetail && (
          <>
            <Feedback
              form=""
              actionStatus={{ shouldShow: isCopyLinkSuccess, variant: "success", timer: FEEDBACK_TIMER }}
              message="Link Copied."
            />

            <Grid item xs={12} display="flex" sx={{ flexDirection: { xs: "column", sm: "row" } }}>
              <Grid item xs={12} sm={6}>
                <CustomContentIcon type="plan" isCustom={selectedMyPlanDetail.isPlanCustomized} />
                <Typography variant="h4" showBold color={tokens.Text.General.PrimaryHeadline}>
                  {selectedPlanDetail?.name}
                </Typography>
              </Grid>
              {isMobileScreen && (
                <>
                  {getPropInfo()}
                  {getOwners()}
                </>
              )}
              <Grid
                item
                xs={12}
                sm={6}
                display="flex"
                gap={"8px"}
                alignSelf="right"
                justifyContent={{ xs: "space-between", sm: "flex-end" }}
                alignItems={"center"}
                marginTop={{ xs: "16px", sm: 0 }}
                className="myplan-action-wrapper"
              >
                {plansType === planTypes.MyPlans && selectedMyPlanDetail?.innCode !== ABOVE_PROPERTY && !isViewMode && (
                  <Grid
                    item
                    display={"flex"}
                    flexDirection={"row"}
                    gap={"8px"}
                    alignItems={"center"}
                    sx={{ flexGrow: isMobileScreen && 1 }}
                    className="toggle-time-wrapper"
                  >
                    <HighlightAction />
                  </Grid>
                )}
                {plansType === planTypes.AllPlans && (
                  <>
                    {(location?.state?.isMyLists || !redirectFromDashboard) && (
                      <>
                        <BookmarkPlan
                          innCodeForPayload={location?.state?.isMyLists ? DEFAULT_CORP_INNCODE : innCode}
                          isBookmarked={
                            location?.state?.isMyLists
                              ? isBookmarked(selectedPlanDetail?.id, DEFAULT_CORP_INNCODE)
                              : isPlanBookmark
                          }
                          cmsId={selectedPlanDetail.id}
                          view={"planDetails"}
                        />
                        <Divider
                          sx={{
                            height: "12px",
                            width: "1px",
                            backgroundColor: tokens.Border.General.Secondary
                          }}
                          orientation="vertical"
                        ></Divider>
                      </>
                    )}
                  </>
                )}
                <Timing duration={getPlanDuration(selectedPlanDetail?.sections)} />
                {plansType !== planTypes.MulipleAssign && (
                  <KebabMenu options={plansType === planTypes.MyPlans ? SectionMenu : PlanMenu} />
                )}
              </Grid>
            </Grid>

            {!isMobileScreen && (
              <>
                {getPropInfo()}
                {getOwners()}
              </>
            )}
          </>
        )}

        <Grid item xs={12} sm={12} marginTop={isMobileScreen ? "16px" : "10px"} sx={{ overflowWrap: "break-word" }}>
          <Grid xs={12} sm={6}>
            <Typography component="div" variant={"body2"} color={tokens.Text.General.PrimaryBody}>
              <HTMLRenderer content={selectedPlanDetail?.summary} />
            </Typography>
          </Grid>
        </Grid>
        {plansType === planTypes.MyPlans && !isTemplatePlan && getInfoBarList()}
        {(plansType === planTypes.AllPlans || plansType === planTypes.MulipleAssign) && (
          <>
            {selectedPlanDetail.isTargeted && (
              <Grid item marginTop={2} xs={12}>
                <TargetedPlanChip variant="horizontal" />
              </Grid>
            )}
            <Grid item xs={12} sm={8} marginTop={2} display={"flex"} gap={"8px"}>
              <FunctionalAreas direction="row" functionalAreaIds={selectedPlanDetail?.functionalAreaIds} />
            </Grid>
          </>
        )}

        {plansType === planTypes.AllPlans && (
          <Grid
            item
            xs={12}
            marginTop={"28px"}
            display="flex"
            alignItems={"flex-start"}
            gap={"4px"}
            flexDirection="column"
          >
            {(isSuggestedPannel || showDashboardMetrics) && (
              <Box
                display="flex"
                flexDirection={"row"}
                flexWrap={"wrap"}
                maxWidth={isMobileScreen ? "100%" : "80%"}
                marginLeft="-22px"
              >
                {metrics &&
                  Object.keys(metrics).map((metric: any, index: any) => {
                    return (
                      <>
                        <MetricDetails
                          key={metric}
                          metric={metrics[metric]}
                          metricsBar={true}
                          sx={{ marginX: "16px", width: isMobileScreen ? "100%" : "320px" }}
                        />
                        {Object.keys(metrics).length > index + 1 && !isMobileScreen && (
                          <Divider
                            sx={{
                              backgroundColor: tokens.Border.General.Tertiary
                            }}
                            orientation="vertical"
                            flexItem
                          ></Divider>
                        )}
                      </>
                    );
                  })}
              </Box>
            )}
            <Grid item xs={12} className="allPlans-wrapper">
              {!selectedPlanDetail.isPlanNotImplemented && <PlanBadge navigate={navigate} data={selectedPlanDetail} />}
              {getLibraryAllPlansActionButtons()}
            </Grid>
          </Grid>
        )}

        {plansType === planTypes.MyPlans && !isViewMode && (
          <>
            {isTemplatePlan ? (
              <Grid
                item
                xs={12}
                gap="20px"
                marginTop={2}
                display="flex"
                alignItems={"center"}
                justifyContent={{ md: "flex-end", xs: "space-between" }}
              >
                {getAssignPlanButtonForTemplatePlans()}
              </Grid>
            ) : (
              <>
                <Grid className="myPlan-right-buttons" item xs={12} md={5}>
                  <Box className="myPlans-right-upper-buttons">
                    <ButtonLink
                      sx={{ marginLeft: isMobileScreen ? "" : "unset", textDecoration: "underline" }}
                      onClick={() => {
                        setOpenInviteMemberDialog(true);
                      }}
                      text="Manage Plan Members"
                      textVariant={"body1"}
                      underline="always"
                      showBold={true}
                    />
                    {members?.length > 0 && <UserAvatarList users={members} max={3} />}
                  </Box>

                  <Box className="myPlans-right-lower-buttons">
                    {getLoggedInUserDetails()?.roleCategory === "Leadership" &&
                      matchOwnerWithHltId(selectedMyPlanDetail?.owners) && (
                        <Button
                          variant="outlined"
                          label="Create Copy & Assign"
                          accessType={accessTypes.update}
                          onClick={() => {
                            setIsAssignCopy(true);
                            setIsOpenPlanAssignmentDialog(true);
                          }}
                        />
                      )}

                    {!isTemplatePlan && getMarkCompleteButton()}
                  </Box>
                </Grid>
              </>
            )}
          </>
        )}
      </Grid>

      {plansType === planTypes.MyPlans && isStagnant && (
        <div style={{ marginTop: "24px" }}>
          <AccessBanner
            label={translate(isCorp ? "myplanDetails.inActivityForCorp" : "myplanDetails.inActivity").replace(
              "MM/DD/YYYY",
              formatDateMMDDYYYY(selectedPlanDetail?.lastModifiedDate)
            )}
          />
        </div>
      )}

      {openEditPlan && <Edit openEditPlan={openEditPlan} setOpenEditPlan={setOpenEditPlan} />}

      {openAddToMyPlanConfirmDialog && (
        <DialogFormation
          title="Add plan"
          openDialog={true}
          handleClose={() => setOpenAddToMyPlanConfirmDialog(false)}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={() => setOpenAddToMyPlanConfirmDialog(false)} />
              <Button
                variant="primary"
                label="Proceed"
                onClick={() => {
                  setOpenAddDueDate(true);
                  setOpenAddToMyPlanConfirmDialog(false);
                }}
              />
            </div>
          }
        >
          The plan has already been added to My Plans on {addedToMyPlansDate}. Do you want to add another copy of this
          plan?
        </DialogFormation>
      )}

      {openDialog && (
        <DialogFormation
          title="Reorder Sections"
          openDialog={openDialog}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCloseDialog} width="25%" />
              <Button disabled={!isSaveEnabled} variant="primary" label="Save" onClick={saveReorder} width="25%" />
            </div>
          }
        >
          <DraggableList items={items} onDragEnd={onDragEnd} />
        </DialogFormation>
      )}

      {openDeleteCapthaDialog && (
        <Delete
          source="myplandetails"
          openDeleteCapthaDialog={openDeleteCapthaDialog}
          setOpenDeleteCapthaDialog={setOpenDeleteCapthaDialog}
          plan={selectedPlanDetail}
          handleInviteDialog={() => setOpenInviteMemberDialog(true)}
        />
      )}
      <InviteMemberDialog
        openInviteMemberDialog={openInviteMemberDialog}
        setOpenInviteMemberDialog={setOpenInviteMemberDialog}
      />

      {isOpenPlanAssignmentDialog && (
        <PlanAssignment
          open={isOpenPlanAssignmentDialog}
          handleCloseDialog={handleClose}
          plans={isAssignCopy ? [selectedMyPlanDetail] : [selectedPlanDetail]}
          flow="third"
          inncodes={
            plansType === planTypes.AllPlans
              ? [selectedPlanDetail.inncode]
              : isAssignCopy
              ? [selectedMyPlanDetail.innCode]
              : null
          }
          isTemplatePlan={isAssignCopy || plansType === planTypes.AllPlans ? false : isTemplatePlan}
          corpUserSelection={isConsultant}
          userSelectionFlow={isConsultant ? "one" : "third"}
          isAssignCopy={isAssignCopy}
          sharedSearch={sharedSearch}
        />
      )}

      {openAddDueDate && (
        <DialogFormation
          title="Select a due date"
          openDialog={openAddDueDate}
          handleClose={() => setOpenAddDueDate(false)}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={() => setOpenAddDueDate(false)} width="25%" />
              <Button
                variant="primary"
                label={translate("library.addToMyPlan")}
                onClick={addToMyPlansHandler}
                width="25%"
              />
            </div>
          }
        >
          <div className="horizontal-center">
            <Box width="320px">
              {selectedPlanDetail?.planType === brandDeadlinesType && (
                <Typography
                  variant="body2"
                  color={tokens.Text.General.PrimaryBody}
                  sx={{ width: "284px", marginBottom: "24px", marginLeft: "24px" }}
                >
                  <strong>
                    {translate("library.addToMyPlan.popup.desc")}{" "}
                    {getUIFormatDate(selectedPlanDetail?.brandDeadlines[0]?.deadline)}.
                  </strong>
                  <div>{translate("library.addToMyPlan.popup.subDesc")}</div>
                </Typography>
              )}
              <Calender
                sx={{ marginLeft: isMobileScreen ? "0px" : "80px", width: isMobileScreen ? "100%" : "auto" }}
                showLable={false}
                buttonView={false}
                onChange={(val: any) => setDueDate(val)}
              />
              {dueDate > selectedPlanDetail?.brandDeadlines[0]?.deadline && (
                <Box marginTop={"8px"} display={"flex"} textAlign={"left"}>
                  <Typography
                    variant={"label"}
                    children={translate("library.addToMyPlan.popup.beyondDate")}
                  ></Typography>
                </Box>
              )}
            </Box>
          </div>
        </DialogFormation>
      )}
      {openImplementedPlans && !implementedPlansLoader && (
        <AddToMyPlans
          openDialog={openImplementedPlans}
          handleClose={() => setOpenImplementedPlans(false)}
          startNewPlan={startNewPlan}
        />
      )}
    </>
  );
}
